/* eslint-disable quotes */
import { openDB } from "./indexeddb.service";

const DB_NAME = "supplementsDB";
const DB_VERSION = 1;
const STORE = "supplements";

// Opens/creates the DB and the "supplements" store with primary key "id"
export function getSupplementsDB() {
  return openDB(DB_NAME, DB_VERSION, (db, oldV) => {
    if (oldV < 1) {
      db.createObjectStore(STORE, { keyPath: "id" });
    }
  });
}

export { STORE as SUPPLEMENTS_STORE };
